import { useEffect } from 'react';

import type { Hook } from './types';

export const useBodyScrollLock: Hook = ({
  isLocked,
}) => {
  useEffect(() => {
    if (isLocked) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }

    return () => {
      document.body.style.overflow = 'vislible';
    };
  }, [isLocked]);
};
